__turbopack_context__.v({
  "chartContainer": "interestRateCBChart-module-scss-module__-TnH8G__chartContainer",
  "chartTitle": "interestRateCBChart-module-scss-module__-TnH8G__chartTitle",
  "date": "interestRateCBChart-module-scss-module__-TnH8G__date",
  "description": "interestRateCBChart-module-scss-module__-TnH8G__description",
  "percentage": "interestRateCBChart-module-scss-module__-TnH8G__percentage",
  "tooltipContainer": "interestRateCBChart-module-scss-module__-TnH8G__tooltipContainer",
});
